import { Box, Button, Paper, useTheme, Typography, CircularProgress, Icon, TextField, IconButton, LinearProgress, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Grid, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Select, InputLabel, MenuItem, FormGroup, Checkbox, Pagination, Slider, ClickAwayListener } from '@mui/material';
import { useState, useEffect } from "react";

import { array } from "yup";
import { useNavigate } from "react-router-dom";
import { Environment } from "../../shared/environment";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { useAppThemeContext } from "../../shared/contexts";
import { VForm, VTextField, useVForm } from "../../shared/forms";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";
import { AlertSnackBar, AutoCompleteDeCliente, FerramentaDeDetalhe } from "../../shared/components";
import { AutoCompleteDeTipoDeCaixa } from "../../shared/components/autocompletes/AutoCompleteDeTipoDeCaixa";
import { EtiquetaService, IEstante, IEstanteRetorno } from "../../shared/services/api/Etiqueta/EtiquetaService";



export const GerarEtiqueta: React.FC = () => {
    interface IFormData {
        estanteInicial: string,
        alturaInicial: string,
        comprimentoInicial: string,
        estanteFinal: string,
        alturaFinal: string,
        comprimentoFinal: string,

    }
    const theme = useTheme();

    const { themeName } = useAppThemeContext();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();

    const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [estantes, setEstantes] = useState</*IEstante[] | */IEstanteRetorno[]>([]);
    const [disponivel, setDisponivel] = useState<boolean>(true);

    const [abrirApagarTodos, setAbrirApagarTodos] = useState<boolean>(false);
    const [abrirApagar, setAbrirApagar] = useState<boolean>(false);

    const [selected, setSelected] = useState<boolean[]>(Array(estantes.length).fill(false));
    const [selectedEst, setSelectedEst] = useState<IEstante[]>([]);

    const [cnpj, setCnpj] = useState<string>("");

    const handleCheckInputs = (dados: Record<string, any>) => {
        if (!!dados.estanteInicial &&
            !!dados.estanteFinal &&
            !!dados.comprimentoInicial &&
            !!dados.comprimentoFinal &&
            !!dados.alturaInicial &&
            !!dados.alturaFinal) {
            return false;
        }
        return true;
    }

    const handleClickDeleteAll = () => {
        setIsLoading(true);
        EtiquetaService.deleteByEstante([...estantes.map((estante) => { return estante.idCoord })]).then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Apagado com sucesso" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);

                setEstantes([]);
                setAbrirApagarTodos(false);
            }
        })
    }

    const handleClickDelete = () => {
        setIsLoading(true);

        EtiquetaService.deleteByEstante([selectedEst[0].idCoord]).then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Apagado com sucesso" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);

                setEstantes(() => {
                    const newArray = estantes.filter((estante) => estante.idCoord !== selectedEst[0].idCoord);
                    return newArray
                });
                setAbrirApagar(false);
            }
        })

    }

    const handleSelect = (index: number, selection: boolean, row: IEstante) => {
        if (selection) {
            setSelectedEst((prevRows) => {

                const selectedRow = [...prevRows]
                selectedRow[index] = row;
                return selectedRow;

            })
        } else {
            setSelectedEst((oldRows) => {
                return [
                    ...oldRows.filter((_, indexToRemove) => indexToRemove !== index),
                ]
            })
        }

        setSelected((prevRows) => {
            const selectedRow = [...prevRows]
            selectedRow[index] = selection;
            return selectedRow;
        })
    }

    const handleSelectedAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selection = event.target.checked;
        setSelected(Array(estantes.length).fill(selection));

        if (selection) {
            setSelectedEst(estantes);
        } else {
            setSelectedEst([]);
        }

    }

    const comporLista = (dados: Record<string, any>) => {
        // var dadosLista: Omit<IEstante, 'idCoord'>[] = [];
        var dadosLista: IEstante[] = [];
        dadosLista.push({
            idCoord: 0,
            numeroEstante: dados.estanteInicial,
            altura: dados.alturaInicial,
            comprimento: dados.comprimentoInicial,
            idTipoCaixa: dados.idTipoCaixa ?? 0,
            cnpj: cnpj
        });

        dadosLista.push({
            idCoord: 0,
            numeroEstante: dados.estanteFinal,
            altura: dados.alturaFinal,
            comprimento: dados.comprimentoFinal,
            idTipoCaixa: dados.idTipoCaixa ?? 0,
            cnpj: cnpj

        });
        return dadosLista;
    }

    const handleGerarEtiqueta = () => {
        if (formRef.current) {
            const dados = formRef.current.getData(); // Obtenha os valores do formulário usando getData()
            if (handleCheckInputs(dados)) {
                setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Preencha todos os campos" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                setIsLoading(true);
                var intervaloEstantes = comporLista(dados);

                handleClearList();

                EtiquetaService.gerarEtiqueta(intervaloEstantes).then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: "Nenhuma etiqueta encontrada no intervalo selecionado" });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);
                    } else {
                        setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Gerando etiquetas" });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);

                        handleClearFields();
                    }

                })
            }
        }
    }

    const handleClearFields = () => {
        formRef.current?.setData({
            estanteInicial: '',
            estanteFinal: '',
            alturaInicial: '',
            alturaFinal: '',
            comprimentoInicial: '',
            comprimentoFinal: '',
        });

        handleClearList();

    }

    const handleClearList = () => {
        setEstantes([]);
        setSelectedEst([]);
        setSelected(Array(estantes.length).fill(false));
    }

    const handleSave = () => {
        if (selectedEst === null || selectedEst === undefined || selectedEst.length === 0) {
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione no mínimo uma etiqueta" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        } else {

            setIsLoading(true);

            const dados: IEstante[] = [];
            dados.push(...selectedEst.filter((estante) => estante !== null && estante !== undefined));

            EtiquetaService.create(dados).then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                } else {
                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Gerando etiquetas" });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);

                    handleClearFields();

                }
            })
        }
    }

    const handleVerificarDisponibilidade = (vazia: boolean) => {
        if (formRef.current) {
            const dados = formRef.current.getData(); // Obtenha os valores do formulário usando getData()
            if (handleCheckInputs(dados)) {
                setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Prencha os campos de estante" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else if ((cnpj === null || cnpj === "" || cnpj === undefined) || (dados.idTipoCaixa === "" || dados.idTipoCaixa === undefined || dados.idTipoCaixa === null) && vazia) {
                setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Prencha todos os campos" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {

                setIsLoading(true);

                handleClearList();

                var intervaloEstantes = comporLista(dados);
                EtiquetaService.verificarDiposnibilidade(intervaloEstantes, vazia).then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {

                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);

                    } else {
                        //@ts-expect-error
                        setEstantes(result);
                        if (vazia) setDisponivel(true);
                        else setDisponivel(false);

                    }
                })
            }
        }
    }


    return (<>

        <LayoutBaseDePagina
            titulo={"Etiqueta"}
            barraDeFerramentas={
                <>
                    <Box
                        component={Paper}
                        height={theme.spacing(5)}
                        marginX={1}
                        padding={1}
                        paddingX={2}
                        display="flex"
                        gap={1}
                        alignItems="center"
                    >

                        <Button
                            color={themeName == 'light' ? 'secondary' : 'primary'}
                            disableElevation
                            variant="outlined"
                            startIcon={<Icon color={themeName == 'light' ? 'secondary' : 'primary'}>arrow_back</Icon>}
                            onClick={() => { navigate(-1) }}
                        >
                            <Typography
                                variant='button'
                                noWrap
                                color={themeName == 'light' ? 'secondary' : 'primary'}
                            >
                                Voltar
                            </Typography>
                        </Button>

                        <Box flex="1" display="flex" justifyContent="end" gap={1}>

                            <Button
                                variant="contained"
                                disabled={isLoading}
                                onClick={() => handleVerificarDisponibilidade(true)}
                                endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                            >
                                Etiquetas disponiveis
                            </Button>

                            <Button
                                variant="contained"
                                disabled={isLoading}
                                onClick={() => handleVerificarDisponibilidade(false)}
                                endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                            >
                                Etiquetas indisponíveis
                            </Button>

                            <Button
                                variant="contained"
                                disabled={isLoading}
                                onClick={() => handleGerarEtiqueta()}
                                endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                            >
                                Reimprimir
                            </Button>

                            <Button
                                variant="contained"
                                startIcon={<Icon>save</Icon>}
                                disabled={isLoading}
                                onClick={() => handleSave()}
                                endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                            >
                                <Typography variant='button' noWrap>
                                    Salvar
                                </Typography>
                            </Button>

                        </Box>
                    </Box>

                </>
            }
        >

            {alertSnackbar !== undefined && (
                <>
                    {alertSnackbar.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}

            <DialogConfirm
                AoConfirmar={handleClickDeleteAll}
                titulo={"Dejesa realmente apagar todas as etiquetas?"}
                texto={"Ao confirmar, todas as etiquetas listadas seram PERMANENTEMENTE apagados."}
                abrir={abrirApagarTodos}
                AoCancelar={() => setAbrirApagarTodos(false)}
            />

            <DialogConfirm
                AoConfirmar={handleClickDelete}
                titulo={"Dejesa realmente apagar essa etiqueta?"}
                texto={"Ao confirmar, a etiqueta será PERMANENTEMENTE apagada."}
                abrir={abrirApagar}
                AoCancelar={() => setAbrirApagar(false)}
            />

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                <Grid container direction="column" padding={5} spacing={2}>
                    <VForm ref={formRef} onSubmit={handleSave}>
                        <Grid container direction="row" padding={2} spacing={2}>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <VTextField fullWidth label="Estante Inicial" placeholder="Digite a estante inicial..." name="estanteInicial" disabled={isLoading} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <VTextField fullWidth label="Estante Final" placeholder="Digite a estante final..." name="estanteFinal" disabled={isLoading} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <AutoCompleteDeCliente paraCadastro isExternalLoading={isLoading} selectedCnpj={selectedCnpj => { if (selectedCnpj !== null && selectedCnpj !== undefined) setCnpj(selectedCnpj) }} />
                            </Grid>

                        </Grid>

                        <Grid container direction="row" padding={2} spacing={2}>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <VTextField fullWidth label="Altura Inicial" placeholder="Digite a altura inicial..." name="alturaInicial" disabled={isLoading} inputProps={{ style: { textTransform: 'uppercase' } }} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <VTextField fullWidth label="Altura Final" placeholder="Digite a altura final..." name="alturaFinal" disabled={isLoading} inputProps={{ style: { textTransform: 'uppercase' } }} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <AutoCompleteDeTipoDeCaixa paraCadastro isExternalLoading={isLoading} />
                            </Grid>

                        </Grid>

                        <Grid container direction="row" padding={2} spacing={2}>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <VTextField fullWidth label="Comprimento Inicial" placeholder="Digite o comprimento inicial..." name="comprimentoInicial" disabled={isLoading} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <VTextField fullWidth label="Comprimento Final" placeholder="Digite o comprimento final..." name="comprimentoFinal" disabled={isLoading} />
                            </Grid>

                        </Grid>

                        {estantes.length !== 0 &&

                            <>
                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }} key="Tabela_Estantes">
                                    <Table>
                                        <TableHead>
                                            <TableRow>

                                                <TableCell key="header_1"> # </TableCell>
                                                <TableCell key="header_2"> Localizador </TableCell>

                                                {disponivel ? (

                                                    <TableCell align="center" key="header_3">

                                                        Marcar todos
                                                        <br />
                                                        <Checkbox
                                                            key={0}
                                                            onChange={handleSelectedAll}
                                                            disabled={isLoading}
                                                        />
                                                    </TableCell>

                                                ) : (

                                                    <>
                                                        <TableCell key="header_4"> Cliente </TableCell>
                                                        <TableCell key="header_5"> Tipo de Caixa</TableCell>

                                                        <TableCell align="center" key="header_6">

                                                            Apagar todos
                                                            <br />
                                                            <IconButton size="small" onClick={() => setAbrirApagarTodos(true)}>
                                                                <Icon>delete</Icon>
                                                            </IconButton>
                                                        </TableCell>
                                                    </>

                                                )}



                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                estantes.map((row, index) => {
                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell key={`cell_${index}_1`}>{index + 1}</TableCell>
                                                            <TableCell key={`cell_${index}_2`}>ZD1-{row.numeroEstante.toString().padStart(3, '0') + "-" + row.altura + "-" + row.comprimento.toString().padStart(3, '0')}</TableCell>

                                                            {disponivel ?
                                                                (
                                                                    <TableCell align="center" key={`cell_${index}_3`}>
                                                                        <Checkbox
                                                                            key={index + 1}
                                                                            checked={selected[index] || false}
                                                                            onChange={(e) => handleSelect(index, e.target.checked, row)}
                                                                            disabled={isLoading}
                                                                        />
                                                                    </TableCell>
                                                                ) : (<>
                                                                    <TableCell key={`cell_${index}_4`}> {row.cliente} </TableCell>
                                                                    <TableCell key={`cell_${index}_5`}> {row.nomeTipo}</TableCell>
                                                                    <TableCell align="center" key={`cell_${index}_6`}>
                                                                        <IconButton size="small" onClick={() => {
                                                                            setSelectedEst(() => {
                                                                                const etiqueta = [row];
                                                                                return etiqueta;
                                                                            });

                                                                            setAbrirApagar(true);

                                                                        }}>
                                                                            <Icon>delete</Icon>
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </>)
                                                            }


                                                        </TableRow>)
                                                })
                                            }

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>

                        }

                    </VForm>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    </>);
}


